import { DatePipe } from '@angular/common';
import { provideRouter } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { provideClientHydration } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { withInterceptorsFromDi, provideHttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';

import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptor/auth.Interceptor';

export const appConfig: ApplicationConfig = {
   providers: [
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      provideZoneChangeDetection({ eventCoalescing: true }),
      importProvidersFrom(TranslateModule.forRoot()),
      provideAnimations(),
      provideHttpClient(withInterceptorsFromDi()),
      provideRouter(routes),
      provideClientHydration(),
      DatePipe
   ]
};
